const IS_BROWSER = process.env.JUPITER_TARGET === 'browser';
const MOUNT_ID = 'root';
const ROUTER_BASE_NAME= '/newslist';
const getRouterBaseName = null


import { createApp, bootstrap } from  '@jupiter-app/runtime';
import ssr from '@jupiter-app/plugin-ssr';

import React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import App from '@_jupiter_src/newslist/App';
import { ThemeProvider } from 'styled-components';

let AppWrapper = null;

const renderApp = () => {
  
  AppWrapper = createApp({
		plugins: [
		ssr({...App?.config?.features?.ssr, ...{"enableHelmet":true}}),
	],
})(App);
    
  bootstrap(AppWrapper, MOUNT_ID)
  
};

renderApp();



export default AppWrapper;


